import React from 'react';
import ReactDOM from 'react-dom/client'; // updated import
import './index.css';
import App from './App';

// import reportWebVitals from './reportWebVitals';
// import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById('root')); // create root

root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();

//serviceWorkerRegistration.register();
